import { graphql } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

import PageHeader404 from "~/components/PageHeader404";

const PageHeader404Block = ({ pageHeader404 }) => (
    <PageHeader404 {...pageHeader404} />
);

PageHeader404Block.propTypes = {
    pageHeader404: PropTypes.shape({
        copy: PropTypes.string,
        subtitle: PropTypes.string,
        title: PropTypes.string.isRequired,
        noMarginBottom: PropTypes.bool,
    }),
};

export default PageHeader404Block;

export const FRAGMENT = graphql`
    fragment PageHeader404BlockFragment on WpAcfPageHeader404Block {
        name
        pageHeader404 {
            title
            noMarginBottom
            copy
            subtitle
        }
    }
`;
